require('../../../corporate-template/js/feature/cookies.js');